import { ConfigStore } from "../../store/modules/config";
import { Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OperationVue } from "../operations/OperationVue";
import IOperationService from "../../services/operations/IOperationService";
import { container } from "@/inversify.config";
import { DiTokens } from "../../services/diTokens";
import { CardBlockModel } from "../../models/cardOperations/CardBlockModel";
import { ContractsStore } from "../../store/modules/contracts";

/**
 *  Класс для компоненты модального окна блокировки карты.
 */
export class CardBlockModalVue extends OperationVue {

  /** Входные параметры */
  @Prop() params!: any;

  /**
 * Хранилище конфигураций
 * @returns {ConfigStore}
 */  
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**
 * Хранилище счетов
 * @returns {ContractsStore}
 */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  /**Инициализация операции */
  async initOperation(): Promise<void> {
    this.loading = true;
    this.service = container.get<IOperationService>(DiTokens.CardBlockService);
    this.OperationModel = (await this.service.init(
      {
        isBlock: this.params.isBlock,
        contract: this.params.contract,
        card: this.params.card
      },
      this.configStore,
      this.contractsStore
    )) as CardBlockModel;
    this.loading = false;
  }
}
